import { VuexModule, Module, getModule, Action } from "vuex-module-decorators";
import store from "@/store";
import { RatingService } from "@/services/api/rating.service";
import { RatingSaveDTO } from "~/rating.type";

@Module({
  dynamic: true,
  store,
  name: "ratingModule",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class RatingVuexModule extends VuexModule {
  @Action
  public async saveRating(req: RatingSaveDTO) {
    const response = await RatingService.saveRating(req);
    return response;
  }
}

export const RatingModule = getModule(RatingVuexModule);
